export default "__VITE_ASSET__7bda81d7__"